module.exports = __webpack_public_path__ + "static/media/camisa.4276edf1.png";